import { Isotope } from 'isotope-layout/dist/isotope.pkgd.js';
import { resizeBackgroundImages } from '../utilities/responsive-images';

/**
 * Initialize Isotope grid for Blog page
 *
 * @param {}
 * @return {void}
 */

export const initializeIsoGrid = (isoGrid = '.js-isotope-grid') => {
  const $isoGrid = $(isoGrid);

  if ($isoGrid.length) {
    const articleImages = $('.js-isotpe-item .js-responsive-background-image');

    $isoGrid.isotope({
      itemSelector: '.js-isotpe-item',
      horizontalOrder: true,
      originLeft: true,
      originTop: true,
      stamp: '.js-isotpe-item-blank',
      getSortData: {
        number: '[data-number]'
      }
    });

    $isoGrid.isotope({ sortBy: 'number' });

    setTimeout(function() {
      resizeBackgroundImages(articleImages);
      $isoGrid.isotope('layout');
    }, 500);
  }
};

$(window).on('load', function(event) {
  initializeIsoGrid();
});
